import { useContext, useState } from "react"

import _ from "lodash"
import { Calendar } from "primereact/calendar"

import { useQuery } from "@apollo/client"
import { SplitButton } from "primereact/splitbutton"
import DateFilterTemplate from "../../components/ReusableComponents/DateFilterTemplate"
// queries
import { useNavigate } from "react-router-dom"
import { ENGAGEMENTS_PARTICIPANT_GROUP_BY_TEMPLATE } from "./queries"

// Context
import { UserContext } from "../../context/userContext"
import { parseDate } from "../../helpers/dateNormalization"
import { DataTable } from "primereact/datatable"
import { Column } from "primereact/column"

import LoaderFullPage from "../../components/Loaders"

import ParticipantSidebar from "../../components/sidebars/ParticipantSidebar"
import ParticipantProfileBoxSmall from "../../components/ParticipantProfileBoxSmall"

import styles from "../../styles/Page-Engagements.module.css"
import { Button } from "primereact/button"
import { navigateWithOrigin } from "../../helpers/navigation"

export default function ManageServices() {
  const [loading, setLoading] = useState(true)
  const [data, setData] = useState(null)
  const userCtx = useContext(UserContext)
  const navigate = useNavigate()

  const ID_TEMPLATES = [
    "intake_session",
    "discharge_session",
    "manage_services",
  ]
  const ID_BLOCKS = [
    "session__discharge",
    "session__intake",
    "session",
    "participant__manage_services",
  ]
  const ID_NAMES_TEMPLATES = {
    intake_session: "Intake Session",
    discharge_session: "Discharge Session",
    manage_services: "Participant Reactivation",
  }

  // Function to check if an object has only empty arrays
  const hasOnlyEmptyArrays = (value) => {
    if (_.isArray(value) && value.length === 0) {
      return false
    } else if (_.isObject(value)) {
      const nonEmptyValues = _.pickBy(value, (innerValue) =>
        hasOnlyEmptyArrays(innerValue)
      )
      return !_.isEmpty(nonEmptyValues)
    }
    return true
  }

  useQuery(ENGAGEMENTS_PARTICIPANT_GROUP_BY_TEMPLATE, {
    variables: {
      participant_id: userCtx.participant_id,
      organization_id: userCtx.session.user.organization_id,
      idTemplates: ID_TEMPLATES,
      idBlocks: ID_BLOCKS,
      participant_membership_id: userCtx.participant_membership_id,
    },
    fetchPolicy: "no-cache",
    skip: !userCtx.session.user.staff_id,
    onCompleted: async (data) => {
      if (data.engagementsParticipant === null) {
        setData(null)
        return setLoading(false)
      }

      const dataFormatted = JSON.parse(data.engagementsParticipant.data)

      const filterManageTypeNotReactivation = _.mapValues(
        dataFormatted,
        (objects) =>
          _.filter(
            objects,
            (obj) =>
              obj.values.idTemplate !== "manage_services" ||
              (obj.values.idTemplate === "manage_services" &&
                obj.values.manage_services_type === "Participant reactivation")
          )
      )

      const result = _.pickBy(filterManageTypeNotReactivation, (value) =>
        hasOnlyEmptyArrays(value)
      )

      _.forEach(result, (objects, key) => {
        _.forEach(objects, (object) => {
          if (_.get(object, "block_name") === "participant__manage_services") {
            _.set(object, "block_name", "session")
          }
        })
      })

      // Function to change the name of the values
      const changeValueName = (obj) => {
        return _.mapValues(obj, (sessions) => {
          return sessions.map((session) => {
            if (_.has(session, "values.manage_services_date")) {
              session.values.session_date = session.values.manage_services_date
              delete session.values.manage_services_date
            }
            return session
          })
        })
      }
      changeValueName(result)

      const handleData = () =>
        _.map(result, (template) => {
          const blocks = _.groupBy(template, "block_name")
          const session = _.isEmpty(blocks?.session) ? {} : blocks?.session[0]

          const handleLocations = () => {
            if (session?.values?.session__location_ids !== undefined) {
              const locationsList = _.map(
                session?.values?.session__location_ids,
                ({ label }) => label
              )
              return _.join(locationsList, ", ")
            } else {
              return "N/A"
            }
          }

          const button =
            ID_NAMES_TEMPLATES[session?.values?.idTemplate] ===
            "Participant Reactivation" ? (
              <Button
                label="View"
                to={`/form/${session?.idTemplate}/1/${session?.idStamp}`}
                onClick={() => {
                  userCtx.changeParticipant(session?.participant_id)
                  navigateWithOrigin(
                    navigate,
                    `/form/view/${session?.idTemplate}/${session?.idStamp}`
                  )
                }}
                style={{ width: "98px" }}
              />
            ) : (
              <SplitButton
                label="View"
                to={`/form/${session?.idTemplate}/1/${session?.idStamp}`}
                onClick={() => {
                  userCtx.changeParticipant(session?.participant_id)
                  navigateWithOrigin(
                    navigate,
                    `/form/view/${session?.idTemplate}/${session?.idStamp}`
                  )
                }}
                model={[
                  {
                    label: "Manage Services",
                    command: () => {
                      navigateWithOrigin(navigate, `/form/manage_services/1/`)
                    },
                  },
                ]}
              />
            )

          if (!_.isEmpty(session)) {
            return {
              date: parseDate(session?.values?.session_date),
              locations: handleLocations(),
              length:
                session?.values?.session_length !== undefined
                  ? `${session?.values?.session_length} minutes`
                  : "N/A",
              channel: session?.values?.session_channel || "N/A",
              facilitating_staff: session?.staff_full_name,
              idTemplate: ID_NAMES_TEMPLATES[session?.values?.idTemplate],
              edit: button,
              recovery_capital: "N/A",
              referral_made: "N/A",
            }
          } else {
            return {}
          }
        })
      setData(handleData())
      setLoading(false)
    },
  })

  const dateBodyTemplate = (rowData) => {
    return formatDate(rowData.date)
  }

  const formatDate = (value) => {
    if (!_.isUndefined(value) && !_.isNull(value)) {
      return value.toLocaleDateString("en-US", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      })
    }
  }

  if (loading) return <LoaderFullPage />

  return (
    <div className="layout-with-sidebar">
      <div className="sidebar">
        <ParticipantSidebar />
      </div>
      <div className="main-content">
        <ParticipantProfileBoxSmall />
        <div>
          <div>
            <h1 className={styles.title}>Manage Services</h1>
            <DataTable
              value={data}
              responsiveLayout="scroll"
              sortField="date"
              sortOrder={-1}
            >
              <Column
                field="date"
                sortable
                header="Date"
                filterField="date"
                dataType="date"
                filter
                filterElement={(options) => (
                  <DateFilterTemplate
                    value={options.value}
                    filterCallback={options.filterCallback}
                    index={options.index}
                  />
                )}
                body={dateBodyTemplate}
              />
              <Column field="locations" header="Location" />
              <Column field="length" header="Length" />
              <Column field="channel" header="Channel" />
              <Column field="facilitating_staff" header="Facilitating Staff" />
              <Column field="idTemplate" header="Type" />
              <Column field="edit" header="Actions" />
            </DataTable>
          </div>
        </div>
      </div>
    </div>
  )
}
